import { render, staticRenderFns } from "./AyudaDiag.vue?vue&type=template&id=3a246fa3"
import script from "./AyudaDiag.vue?vue&type=script&lang=js"
export * from "./AyudaDiag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports